import * as GarageInvoiceModels from '../../models/garage-invoice/garage-invoice';

import { SpecificationModel } from '../../models/specification/specification';
import { SpecificationSearchModel } from '../../models/specification/specificationSearch';
import * as Models from '../../models/commonModels';

export class GetList {
  static readonly type = '[GarageInvoice] List';
  constructor(public Search: GarageInvoiceModels.GarageInvoiceSearchModel) { }
}

export class SetSearch {
  static readonly type = '[GarageInvoice] Set Search';
  constructor(public Search: GarageInvoiceModels.GarageInvoiceSearchModel) { }
}

export class ResetSearch {
  static readonly type = '[GarageInvoice] Reset Search';
  constructor() { }
}

export class SetListPage {
  static readonly type = '[GarageInvoice] Set List Page';
  constructor(public Search: GarageInvoiceModels.GarageInvoiceSearchModel) { }
}

export class Delete {
  static readonly type = '[GarageInvoice] Delete';
  constructor(public GarageInvoiceId: number, public Version: number) { }
}

export class GetLinkedSpecifications {
  static readonly type = '[GarageInvoice] GetLinkedSpecifications';
  constructor(public GarageInvoiceId: number) { }
}

export class Insert {
  static readonly type = '[GarageInvoice] Insert';
  constructor(public Invoice: GarageInvoiceModels.GarageInvoiceModel, public Version: number) { }
}

export class CorrectionRequest {
  static readonly type = '[GarageInvoice] CorrectionRequest';
  constructor(public Request: GarageInvoiceModels.GarageInvoiceCorrectionModel, public Version: number) { }
}

export class ResetSpecificationList {
  static readonly type = '[GarageInvoice] ResetSpecificationList';
  constructor() { }
}

export class GetPrintData {
  static readonly type = '[GarageInvoice] GetPrintData';
  constructor(public GarageInvoiceId: number) { }
}

export class GetCompactPrintData {
  static readonly type = '[GarageInvoice] GetCompactPrintData';
  constructor(public GarageInvoiceId: number) { }
}

export class GetSpecificationList {
  static readonly type = '[GarageInvoice] GetSpecificationList';
  constructor() { }
}

export class AddSpecification {
  static readonly type = '[GarageInvoice] AddSpecification';
  constructor(public Specification: SpecificationModel) { }
}

export class RemoveListItem {
  static readonly type = '[GarageInvoice] RemoveListItem';
  constructor(public SpecificationId: number) { }
}

export class RemoveAllListItem {
  static readonly type = '[GarageInvoice] RemoveAllListItem';
  constructor() { }
}

export class SetGarageInvoice {
  static readonly type = '[GarageInvoice] SetGarageInvoiceState';
  constructor(public GarageInvoice: GarageInvoiceModels.GarageInvoiceModel) { }
}

export class GetGarageInvoice {
  static readonly type = '[GarageInvoice] GetGarageInvoiceState';
  constructor() { }
}

export class AddSelectedSpecificationList {
  static readonly type = '[GarageInvoice] AddSelectedSpecificationList';
  constructor(public Specifications: SpecificationModel[]) { }
}

export class AddFilteredSpecifications {
  static readonly type = '[GarageInvoice] AddFilteredSpecifications';
  constructor(public Search: SpecificationSearchModel) { }
}

export class DisposeSearch {
  static readonly type = '[GarageInvoice] DisposeSearch';
  constructor() { }
}

export class GetGarageInvoiceReport {
  static readonly type = '[GarageInvoice] Report';
  constructor(public Request: Models.Request<GarageInvoiceModels.GarageInvoiceSearchModel>) { }
}
